<template>
  <div class="management-advantages">
    <div class="block-content">
      <block-title :en="section.title.en" :title="section.title.value" :sub="section.title.sub"></block-title>

      <div class="card-list">
        <div class="card-item" v-for="item in section.list" :key="item.title">
          <img class="card-image" :src="item.icon" alt="" />
          <div class="card-content">
            <div class="card-title">{{ item.title }}</div>
            <div class="card-description">{{ item.description }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters(['globalData']),
    section() {
      return this.globalData['rail-transit-equipment-management-system']?.managementAdvantages || { title: {}, list: [] };
    }
  }
};
</script>

<style lang="scss" scoped>
.management-advantages {
  padding: 80px 0;
  background: #f5f9ff;

  * {
    box-sizing: border-box;
  }
}

.card-list {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  margin-top: 60px;
}

.card-item {
  width: calc((100% - 48px) / 3);
  overflow: hidden;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:nth-child(n + 4) {
    width: calc((100% - 24px) / 2);
  }

  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 12px 36px rgba(0, 0, 0, 0.12);
  }
}

.card-image {
  display: block;
  width: 100%;
  height: 260px;
  object-fit: cover;
}

.card-content {
  padding: 24px;
  min-height: 220px;
}

.card-title {
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 700;
  font-size: 24px;
  color: #333333;
  line-height: 34px;
}

.card-description {
  margin-top: 16px;
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 16px;
  color: #909399;
  line-height: 30px;
}
</style>
